const clamp = (val, min, max) => {
  return Math.max(min, Math.min(val, max));
};

export { clamp };
//# sourceMappingURL=clamp.es.js.map
